import { Label as Icon } from "@mui/icons-material";
import { Typography } from "@mui/material";
import type { FC } from "react";
import type { OrderStatus } from "../../data/BaseEntity";
import { StatusColors } from "./StatusColors";
import { orderStatusToName } from "./orderStatusToName";

interface Props {
  value: OrderStatus;
  gutterBottom?: boolean;
}

const OrderStatusView: FC<Props> = ({ value, gutterBottom }) => (
  <Typography gutterBottom={gutterBottom}>
    <Icon
      style={{
        paddingRight: 5,
        verticalAlign: "bottom",
        color: StatusColors[value],
      }}
    />
    {orderStatusToName(value)}
  </Typography>
);

export default OrderStatusView;
